import { BridgeComponent } from '@hotwired/hotwire-native-bridge'

// Le thème choisi (Suivre l'appareil / Clair / Sombre), pour que le chrome natif suive la
// page : envoyé à chaque page (`choice`) et à chaque bascule du sélecteur (theme_controller,
// `explicit`). L'app force son apparence, ou laisse le système décider. Sur le web, rien.
//
// L'app répond à chaque page ouverte, à la bascule et, sur Android, quand le système change
// d'apparence : la page applique ce qu'elle reçoit, sans rechargement. iOS renvoie le choix
// (`theme`), les pages suivent `prefers-color-scheme` pour « Suivre l'appareil » ; Android
// renvoie l'apparence résolue (`dark`), sa WebView ne voyant pas un changement fait sans
// recréer l'écran.
export default class extends BridgeComponent {
  static component = 'theme'
  static values = { choice: String }

  // Sans garde `enabled` : sur une page rechargée à froid, l'app n'a pas encore déclaré ses
  // composants, et l'écoute ne se posait jamais.
  connect() {
    super.connect()
    this.#send(this.choiceValue, false)
    document.addEventListener('theme:changed', this.onChanged)
  }

  disconnect() {
    document.removeEventListener('theme:changed', this.onChanged)
    super.disconnect()
  }

  onChanged = (event) => this.#send(event.detail.theme, true)

  #send(theme, explicit) {
    this.send('change', { theme, explicit }, ({ data }) => this.#applyReply(data))
  }

  #applyReply(data) {
    const root = document.documentElement

    if (typeof data.dark === 'boolean') {
      const scheme = data.dark ? 'dark' : 'light'
      root.dataset.nativeScheme = scheme
      root.setAttribute('data-theme', scheme)
      return
    }

    if (!data.theme) return
    window.Turbo?.cache?.clear() // les captures portent l'ancien thème
    if (data.theme === 'system') {
      root.removeAttribute('data-theme')
      delete document.body.dataset.themePreference
    } else {
      root.setAttribute('data-theme', data.theme)
      document.body.dataset.themePreference = data.theme
    }
  }
}
